// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/growth-score/pages/CompetitorsPage.tsx (ADAPT)
// ADAPTED (plan P4-1, M1, Coverage "Competitors page: real list"): the table of the brands the score is ranked against, with the
// Match as CI's similarity (M1) and each brand's own logo (initial fallback). Not ported, because the BFF has nothing behind
// them and nothing stores them: the Yes / No grading and its reasons, "Calibrate" (the team's Match weights, cut and
// only-with-ads switches), Track / Read its ads, the "why we picked it" parts bar and the Inspiration list. The
// `@[640px]` container query is a normal breakpoint (`sm:`, P4-2).
/**
 * Growth Score → Your comparable cohort: the brands the score ranks against, by Match.
 */
import { ArrowRight, Users } from 'lucide-react'
import { Button } from '@/components/ui/shadcn/button'
import { Card } from '@/components/ui/shadcn/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { GrowthPage, useGrowthNav } from '../GrowthPage'
import { useGrowthScore } from '../GrowthScoreContext'
import { BrandMark, DimensionIcon, ScoreFigure } from '../components/visuals'

export function CompetitorsPage() {
  const vm = useGrowthScore()
  const nav = useGrowthNav()
  const competitors = [...vm.competitors].sort((a, b) => b.match - a.match)

  return (
    <GrowthPage
      title="Your comparable cohort"
      back
      hero={{
        icon: <DimensionIcon icon={Users} />,
        subtitle: 'Match is how close each brand is to you.',
        aside: (
          <div className="flex flex-col items-end gap-0.5">
            <ScoreFigure value={vm.overall} size="lg" />
            <span className="text-label text-ds-text-2">
              {competitors.length} {competitors.length === 1 ? 'competitor' : 'competitors'} in your cohort
            </span>
          </div>
        ),
      }}
    >
      <Card className="overflow-hidden">
        {competitors.length ? (
          <Table aria-label="Comparable cohort">
            <TableHeader>
              <TableRow>
                <TableHead className="w-12">#</TableHead>
                <TableHead>Brand</TableHead>
                <TableHead>Match</TableHead>
                <TableHead className="hidden sm:table-cell">How close</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {competitors.map((b, i) => (
                <TableRow key={b.brandId}>
                  <TableCell className="text-ds-text-3">{i + 1}</TableCell>
                  <TableCell>
                    <span className="flex items-center gap-2">
                      <BrandMark name={b.name} logoUrl={b.logoUrl} size="sm" />
                      <span className="flex min-w-0 flex-col">
                        <span className="text-foreground">{b.name}</span>
                        {b.domain ? <span className="text-label text-ds-text-3">{b.domain}</span> : null}
                      </span>
                    </span>
                  </TableCell>
                  <TableCell className="text-tab text-foreground">{b.match}%</TableCell>
                  <TableCell className="hidden sm:table-cell">
                    <span aria-hidden className="flex h-1.5 w-28 overflow-hidden rounded-full bg-ds-ink-a05">
                      <span className="h-full rounded-full bg-ds-text-2" style={{ width: `${b.match}%` }} />
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <p className="p-5 text-body-sm text-ds-text-2">
            {vm.competitorsSkipped
              ? "You didn't pick competitors in the chat, so there are no brands to list here."
              : "Your cohort will show here once it's ready."}
          </p>
        )}
        <div className="flex flex-wrap items-center justify-between gap-3 border-t border-ds-hairline p-4">
          <span className="text-body-sm text-ds-text-2">Closest match first.</span>
          <Button type="button" onClick={() => nav.open({ kind: 'assessment' })}>
            Back to my score
            <ArrowRight aria-hidden />
          </Button>
        </div>
      </Card>
    </GrowthPage>
  )
}
